@if (content(); as _content) {
  <div class="collapsible-panel">
    <button
      class="collapsible-panel__button"
      (click)="toggleCollapsible($event)">
      <div class="collapsible-panel__button-content">
        @if (_content.icon) {
          <evc-icon
            size="xs"
            [icon]="_content.icon" />
        }
        <span>{{ _content.text | optionalAsync }}</span>
      </div>
      <evc-icon
        size="md"
        [icon]="getIcon()"></evc-icon>
    </button>

    @if (isOpen()) {
      <div class="collapsible-panel__content">
        <ng-content />
      </div>
    }
  </div>
}
